export default {
  Agreement: 'الاتفاق',
  Close: 'إغلاق',
  'Commercial Card Application': 'اتفاقية التاجر',
  'To generate the commercial card application please press the button below.':
    'لإنشاء اتفاقية التاجر ، يرجى الضغط على الزر أدناه.',
  'Generate Commercial Card Application': 'إنشاء اتفاقية التاجر',
  'Sign with DocuSign': 'التوقيع مع دوكوسين',
  'Download contract': 'تحميل العقد',
  'Sign and submit': 'تسجيل وإرسال',
  'Authorised signatory': 'المفوض بالتوقيع',
  'Your agreement has been sent to the {{email}} address to be signed':
    'Your agreement has been sent to the {{email}} address to be signed',
  'Choose another person': 'اختر شخصًا آخر',
  'Who will sign the contract?': 'من سيوقع العقد؟',
  'Select authorised signatory': 'حدد المفوض بالتوقيع',
  'We will send the invitation link to log in to the Portal.': 'سنرسل رابط الدعوة لتسجيل الدخول إلى البوابة.',
  'There is no contract data': 'لا توجد بيانات العقد',
  'I agree to the Terms and Conditions, acknowledge to have received and read the full Terms and Conditions along with this Application':
    'I agree to the Terms and Conditions, acknowledge to have received and read the full Terms and Conditions along with this Application, a copy of the Terms and Conditions (as updated from time to time by Network) is uploaded a ',
  'Terms and Conditions link': 'https://www.network.ae/en/contents/view/merchant-terms-and-conditions',
  'Processing your contract signing with UAE PASS. The signed contract will load once signing process is complete.':
    'معالجة توقيع العقد الخاص بك مع بطاقة الإمارات العربية المتحدة. سيتم تحميل العقد الموقع بمجرد اكتمال عملية التوقيع.',
  'We are fetching information from the UAE PASS. Use your UAE PASS application to allow document sharing.':
    'نحن نجلب المعلومات من بطاقة الإمارات العربية المتحدة. استخدم تطبيق بطاقة الإمارات العربية المتحدة للسماح بمشاركة المستندات.',
  "Failed to fetch information from DocuSign. Press on 'Close' button below to reload this page and try again.":
    "فشل في جلب المعلومات من دوكوسين. اضغط على زر 'إغلاق' أدناه لإعادة تحميل هذه الصفحة وحاول مرة أخرى.",
  'Processing your contract signing with DocuSign. The signed contract will load once signing process is complete.':
    'معالجة توقيع العقد الخاص بك مع دوكوسين. سيتم تحميل العقد الموقع بمجرد اكتمال عملية التوقيع.',
  "The contract has been declined in DocuSign. Press on 'Close' button below to reload this page and try again.":
    "تم رفض العقد في دوكوسين. اضغط على زر 'إغلاق' أدناه لإعادة تحميل هذه الصفحة وحاول مرة أخرى.",
    "Sign and upload Contract below": "Sign and upload Contract below",
};
